import React from 'react';
import InputV1 from '../../../../../components/ComponentsV1/InputV1';
import { Star } from '../../../../../UiKit/Star/Star';

const SopDropdown = ({ title, placeholder, options, value, onChange, loading, disabled, inputClassName }) => (
  <div className='tw-flex tw-flex-col tw-h-max tw-gap-5 tw-flex-1'>
    <div className='tw-w-full tw-text-grey-900 tw-font-medium tw-text-500'>
      {title} <Star icon='*' />
    </div>
    <div className='tw-flex tw-flex-col tw-w-full'>
      <InputV1
        loading={loading}
        options={options || []}
        placeholder={placeholder}
        multiple={false}
        isSearchable
        disabled={disabled}
        inputProps={{
          className: 'tw-border-none',
          type: 'text',
          style: { width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
        }}
        inputClassName={inputClassName}
        style={{ width: '100%', display: 'block' }}
        closeOnSelect
        onSelect={(selectedValue) => onChange(selectedValue ?? null)}
        value={value ? value.value : undefined}
      />
    </div>
  </div>
);

export default SopDropdown;
